// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { resetSessionReduxState } from '../redux/sessionReset';

const ProtectedRoute = ({ children, setIsAuthenticated }) => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');

  if (!token) {
    setIsAuthenticated(false); // Update authentication status
    return <Navigate to="/login" />;
  }

  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decodedToken.exp < currentTime) {
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
      resetSessionReduxState();
      setIsAuthenticated(false); // Update authentication status
      return <Navigate to="/login" />;
    }
  } catch (error) {
    console.error('Invalid token:', error);
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    resetSessionReduxState();
    setIsAuthenticated(false); // Update authentication status
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
